import { QuestionnaireQuestion } from "@repo/api";
import { FC } from "react";
import { RadioGroup, RadioInput } from "../../Form";
import * as Styled from "./QuestionnairePage.styled";

export const QuestionnaireQuestionSingleChoice: FC<{
    question: QuestionnaireQuestion;
}> = ({ question }) => {
    return (
        <RadioGroup name={`${question.id}`}>
            {question.answers?.map((answer) => (
                <RadioInput
                    key={`${question.id}-${answer.id}`}
                    id={`${question.id}-${answer.id}`}
                    name={`${question.id}`}
                    label={answer.text}
                    value={answer.id}
                    LabelTextComponent={Styled.QuestionnaireQuestionAnswerLabel}
                />
            ))}
        </RadioGroup>
    );
};
